import React from "react";

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * Section
 * - Wrapper to enforce vertical spacing between blocks.
 * - Accepts className for grids/layouts defined by templates.
 */
export function Section({ className = "", children, ...props }) {
  return (
    <section className={cx(className)} {...props}>
      {children}
    </section>
  );
}


